import { render, staticRenderFns } from "./DiceSlide.vue?vue&type=template&id=67e22478"
import script from "./DiceSlide.vue?vue&type=script&lang=js"
export * from "./DiceSlide.vue?vue&type=script&lang=js"
import style0 from "./DiceSlide.vue?vue&type=style&index=0&id=67e22478&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67e22478')) {
      api.createRecord('67e22478', component.options)
    } else {
      api.reload('67e22478', component.options)
    }
    module.hot.accept("./DiceSlide.vue?vue&type=template&id=67e22478", function () {
      api.rerender('67e22478', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/slides/DiceSlide.vue"
export default component.exports